import { jsxs as o, jsx as s } from "react/jsx-runtime";
import r from "clsx";
import a from "./Loading.module.css.js";
const e = ({ className: i }) => /* @__PURE__ */ o(
  "div",
  {
    "aria-label": "Loading...",
    role: "status",
    className: r(a.container, i),
    children: [
      /* @__PURE__ */ s("div", { className: a.overlay }),
      /* @__PURE__ */ s("div", { className: a.spinner })
    ]
  }
);
e.displayName = "Loading";
export {
  e as Loading
};
//# sourceMappingURL=Loading.js.map
